import { render, staticRenderFns } from "./ConfirmAccessAccountModal.vue?vue&type=template&id=5a5a6c34&scoped=true&"
import script from "./ConfirmAccessAccountModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmAccessAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmAccessAccountModal.vue?vue&type=style&index=0&id=5a5a6c34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5a6c34",
  null
  
)

export default component.exports